/**
 *
 */
import {Fancybox} from '@fancyapps/ui';


/**
 * add lightbox functionality to all virtual tour thumbnails
 *
 * @param grouped
 */
const setupCommunityVirtualTours = ( grouped = false ) =>
{
	if (grouped) {
		setupGrouped();
	} else {
		setupSingle();
	}
};


/**
 * setup lightbox so that each virtual tour is only accessible from its thumbnail
 *
 * @see https://fancyapps.com/docs/ui/fancybox/api
 * @see https://fancyapps.com/docs/ui/fancybox/options
 */
const setupSingle = () =>
{
	const thumbs = document.querySelectorAll( '#community-virtual-tours-page .gallery-thumb' );


	thumbs.forEach( thumb =>
	{
		const link = thumb.querySelector( '.btn' );

		if (link instanceof HTMLElement) {

			thumb.addEventListener( 'click', e =>
			{
				e.preventDefault();
				e.stopPropagation();

				new Fancybox( [
					{
						src:     link.href,
						type:    'iframe',
						thumb:   link.dataset.thumb,
						preload: true,
					}
				], {
					mainClass: 'gallery-lightbox virtual-tours-lightbox',
					caption:   () => link.getAttribute( 'title' ),
				} );
			} );
		}
	} );
};


/**
 * setup lightbox with bottom navigation to other virtual tours
 *
 * @see https://fancyapps.com/docs/ui/fancybox/api
 * @see https://fancyapps.com/docs/ui/fancybox/options
 */
const setupGrouped = () =>
{
	const thumbs = document.querySelectorAll( '#community-virtual-tours-page .gallery-thumb' );
	const slides = [];


	thumbs.forEach( thumb =>
	{
		const link = thumb.querySelector( '.btn' );

		if (link instanceof HTMLElement) {
			slides.push( {
				src:     link.href,
				type:    'iframe',
				thumb:   link.dataset.thumb,
				title:   link.getAttribute( 'title' ),
				preload: true,
			} );
		}
	} );

	thumbs.forEach( ( thumb, key ) =>
	{
		thumb.addEventListener( 'click', e =>
		{
			e.preventDefault();
			e.stopPropagation();

			new Fancybox( slides, {
				startIndex: key,
				mainClass:  'gallery-lightbox virtual-tours-lightbox',
				caption:    ( fb, opts, image ) => slides[image.index].title,
			} );
		} );
	} );
};


/**
 *
 */
export default setupCommunityVirtualTours;